'use client';

function isOverflowSet(overflowValue) {
    return (overflowValue === 'auto' ||
        overflowValue === 'hidden' ||
        overflowValue === 'scroll' ||
        overflowValue === 'overlay');
}

export { isOverflowSet as default };
//# sourceMappingURL=isOverflowSet.js.map
